module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNSAxNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBvcGFjaXR5PSIuOSI+PGcgb3BhY2l0eT0iLjciIHRyYW5zZm9ybT0icm90YXRlKC02IDcuMyA1LjcpIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxyZWN0IGZpbGw9IiNGRkYiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgcng9IjciLz48cGF0aCBkPSJNNyAxM0E2IDYgMCAxIDAgNyAxYTYgNiAwIDAgMCAwIDEyem0uNi00LjRMNiA2LjkgMyA4LjYgNi4zIDUgOCA2LjcgMTEgNSA3LjYgOC42eiIgZmlsbD0iIzAwODRGRiIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9nPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/img/fbm-mini-logo.svg
// module id = 75
// module chunks = 35783957827783 79611799117203 85929988179075 182101406987512